import { Link } from "react-router-dom";
import logo from "@/assets/logo.jpg";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary text-secondary-foreground" role="contentinfo">
      <div className="container py-12 md:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img src={logo} alt="Upgrade Skills Ltd" className="h-16 w-auto mb-4 rounded bg-background p-2" width={83} height={64} />
            <p className="text-secondary-foreground/80 max-w-md mb-4">
              Helping people enhance employability with English and Maths courses, plus employability workshops. 
              Serving Rainham and nearby areas.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-display font-bold text-lg mb-4">Quick Links</h3>
            <nav aria-label="Footer navigation">
              <ul className="space-y-2">
                <li>
                  <a href="#services" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                    Courses
                  </a>
                </li>
                <li>
                  <a href="#how-it-works" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                    How It Works
                  </a>
                </li>
                <li>
                  <a href="#about" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                    About
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-display font-bold text-lg mb-4">Legal</h3>
            <nav aria-label="Legal navigation">
              <ul className="space-y-2">
                <li>
                  <Link to="/privacy" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/cookies" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                    Cookie Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link to="/accessibility" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                    Accessibility
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <hr className="my-8 border-secondary-foreground/20" />

        {/* Company Details */}
        <div className="grid md:grid-cols-2 gap-6 text-sm text-secondary-foreground/70">
          <div>
            <p><strong>Registered Company:</strong> Upgrade Skills Ltd</p>
            <p><strong>Company Number:</strong> 14707029</p>
            <p><strong>Registered in:</strong> England & Wales</p>
          </div>
          <div>
            <p><strong>Registered Office:</strong></p>
            <address className="not-italic">
              CEME Campus, Marsh Way, Rainham, Essex, RM13 8EU
            </address>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-secondary-foreground/20 text-center text-sm text-secondary-foreground/70">
          <p>© {currentYear} Upgrade Skills Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}